import * as yup from "yup";

export const NPI_VALIDATION_SCHEMA = yup.object().shape({
  npi: yup
    .string()
    .matches(/^[0-9-]*$/, "Invalid Practitioner NPI or TIN number")
    .min(10, "Invalid Practitioner NPI or TIN number")
    .max(10, "Invalid Practitioner NPI or TIN number")
    .required("Enter a Practitioner NPI or TIN number"),
});
